let CACHE_VALID_TIME_MS = 60000;

class APICache {

    constructor() {
        this.entries = {};
    }

    clear() {
        this.entries = {};
    };

    cacheResult(key, results) {
        let now = new Date().getTime();
        let validTo = now + CACHE_VALID_TIME_MS;
        this.entries[key] = [validTo, results];
    };


    cachedResult(key) {
        if (key in this.entries) {
            let entry = this.entries[key];
            let now = new Date().getTime();
            if (now < entry[0]) {
                return entry[1];
            }
        }
        return null;
    };
}


class APIHelper {


    constructor(apiBase) {
        this.apiBase = apiBase;
        this.cache = new APICache();
    }

    /*
     * options:
     *   action
     *   args
     *   jsonData
     *   formData
     *   onOK
     *   onError
     *   onResult
     */
    doCall(path, option) {

        //prod
        let url = this.apiBase + path;

        let handler = new APIHandler(this, path, option);
        option.formData = nullIfUndefined(option.formData);
        option.jsonData = nullIfUndefined(option.jsonData);
        let isForm = option.formData !== null;
        let isJSON = option.jsonData !== null;
        let data = isForm ? option.formData : isJSON ? JSON.stringify(option.jsonData) : option.args;
        let cache = false;
        if (option.cache !== undefined) {
            cache = option.cache;
        }
        let contentType = isJSON ? "application/json; charset=utf-8" : "application/x-www-form-urlencoded; charset=UTF-8";
        let dataType = isJSON ? "json" : null;
        appLog(option.type + ':' + url + ' ' + JSON.stringify(data));

        if (option.type === "GET") {
            let cachedResult = this.cache.cachedResult(path);
            if (cachedResult !== null) {
                handler.onSuccess(cachedResult);
                return;
            }
        }

        let headers = {};
        if (option.csrfmiddlewaretoken !== undefined) {
            headers = {"X-CSRFToken": option.csrfmiddlewaretoken};
        }

        $.ajax({
            type: option.type,
            url: url,
            data: data,
            cache: cache,
            contentType: contentType,
            dataType: dataType,
            success: handler.onSuccess.bind(handler),
            error: handler.onError.bind(handler),
            headers: headers
        }, "json");
    };

    get(path, options) {
        options.type = "GET";
        this.doCall(path, options);
    };

    post(path, options) {
        options.type = "POST";
        this.doCall(path, options);
    };


}

class APIHandler {

    constructor(api, path, option) {
        this.option = option;
        this.api = api;
        this.path = path;
    }


    onSuccess(data) {
        if (this.option.type === "GET") {
            this.api.cache.cacheResult(this.path, data);
        }

        if (this.option.onResult !== undefined) {
            this.option.onResult(data);
        }
    };

    onError() {
        if (this.option.onError !== undefined) {
            this.option.onError();
        }
    };
}
